import { useState, useEffect, type ReactNode } from "react";
import { UserContext, type User } from "./UserContextUtils";
import { userDetail } from "../api/Api"; // Ensure path is correct
import { handleFetch } from "../Utils/Utils";

export function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    handleFetch<{ data: User }>(
      userDetail,
      (data) => setUser(data.data),
      () => setUser(null) // 401
    ).finally(() => setInitialized(true));
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, initialized }}>
      {children}
    </UserContext.Provider>
  );
}
